module.exports = __webpack_public_path__ + "media/products/car1-1e7be68e.png";